import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../packages/auth-client';

/**
 * RestrictedRedirect — blocks a route subtree for restricted (project- or
 * task-restricted) users, sending them to /home (which resolves to their
 * project). Used on the routes whose nav links / project tabs we hide, so they
 * can't be reached by typing the URL either. Non-restricted users pass through.
 */
export function RestrictedRedirect() {
    const { isRestricted } = useAuth();
    return isRestricted() ? <Navigate to="/home" replace /> : <Outlet />;
}
